import type { TabCardProps } from "@op/puck-types";
import { Print_Dc_Card_Tabs } from "@op/sf-op";
import TabCardItem from "../../../../../components/puck/TabCardItem/TabCardItem";

const TabCard = ({ items }: TabCardProps) => {
  return (
    <Print_Dc_Card_Tabs>
      {items.map((item, idx) => (
        <TabCardItem key={`${item.title}-${idx}`} {...item} />
      ))}
    </Print_Dc_Card_Tabs>
  );
};

export default TabCard;
